
namespace Matrix.Dashboards {

    export interface IDashboardDesigner {
        openDesigner: (propertyName?: string) => void;
    }
}